var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cmp cmp-method-list list mb-4",
      class: { error: _vm.showError },
    },
    [
      _c(
        "ul",
        {
          staticClass: "method-list component-loading",
          class: {
            "is-loading": _vm.isBasketLoading || _vm.isCheckoutReadonly,
          },
        },
        [
          _vm._l(_vm.shippingProfileList, function (shippingProfile) {
            return _c(
              "li",
              {
                staticClass: "method-list-item",
                attrs: { "data-id": shippingProfile.parcelServicePresetId },
              },
              [
                _c("input", {
                  attrs: {
                    type: "radio",
                    id:
                      "ShippingProfileID" +
                      _vm._uid +
                      shippingProfile.parcelServicePresetId,
                    name: "shippingProfileSelect" + _vm._uid,
                    disabled:
                      _vm.isBasketLoading ||
                      _vm.isCheckoutReadonly ||
                      (_vm.paymentContainerIsOverwritten &&
                        _vm.isPaymentMethodExcluded(
                          shippingProfile,
                          _vm.selectedPaymentMethodId
                        )),
                  },
                  domProps: {
                    value: shippingProfile.parcelServicePresetId,
                    checked:
                      _vm.shippingProfileId ===
                      shippingProfile.parcelServicePresetId,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.onShippingProfileChange(
                        shippingProfile.parcelServicePresetId
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.isPaymentMethodExcluded(
                          shippingProfile,
                          _vm.selectedPaymentMethodId
                        ),
                        expression:
                          "isPaymentMethodExcluded(shippingProfile, selectedPaymentMethodId)",
                      },
                    ],
                    staticClass: "provider-select-label",
                    class: _vm.paddingClasses,
                    style: _vm.paddingInlineStyles,
                    attrs: {
                      for:
                        "ShippingProfileID" +
                        _vm._uid +
                        shippingProfile.parcelServicePresetId,
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      "data-title": _vm.getTooltip(
                        shippingProfile.parcelServicePresetId,
                        _vm.selectedPaymentMethodId
                      ),
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "icon mh-32",
                        class: {
                          "w-33 ml-8":
                            shippingProfile.parcelServicePresetId == 29,
                        },
                      },
                      [
                        shippingProfile.parcelServicePresetId == 7
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-fedex",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 8
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-dhl",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 9
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-dhl",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 12
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-fedex",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 13
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-collect",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 15
                          ? [
                              _c(
                                "svg",
                                {
                                  staticClass: "scale-2-5",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-ups",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 16
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-fedex",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 17
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-dhl",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 18
                          ? _c("lazy-img", {
                              attrs: {
                                "picture-class": "img-fluid",
                                "image-url":
                                  _vm.pluginPath + "/images/postnord.svg",
                                alt: "PostNord",
                              },
                            })
                          : shippingProfile.parcelServicePresetId == 20
                          ? _c("lazy-img", {
                              attrs: {
                                "picture-class": "img-fluid",
                                "image-url":
                                  _vm.pluginPath + "/images/postnord.svg",
                                alt: "PostNord",
                              },
                            })
                          : shippingProfile.parcelServicePresetId == 21
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-collect",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 22
                          ? [
                              _c(
                                "svg",
                                {
                                  staticClass: "scale-2-5",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-ups",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 23
                          ? [
                              _c(
                                "svg",
                                {
                                  staticClass: "scale-2-5",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-ups",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 24
                          ? [
                              _c(
                                "svg",
                                {
                                  staticClass: "scale-2-5",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-ups",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 25
                          ? _c("lazy-img", {
                              attrs: {
                                "picture-class": "img-fluid",
                                "image-url":
                                  _vm.pluginPath + "/images/postnord.svg",
                                alt: "PostNord",
                              },
                            })
                          : shippingProfile.parcelServicePresetId == 26
                          ? _c("lazy-img", {
                              attrs: {
                                "picture-class": "img-fluid",
                                "image-url":
                                  _vm.pluginPath + "/images/postnord.svg",
                                alt: "PostNord",
                              },
                            })
                          : shippingProfile.parcelServicePresetId == 27
                          ? _c("lazy-img", {
                              attrs: {
                                "picture-class": "img-fluid",
                                "image-url":
                                  _vm.pluginPath + "/images/postnord.svg",
                                alt: "PostNord",
                              },
                            })
                          : shippingProfile.parcelServicePresetId == 28
                          ? _c("lazy-img", {
                              attrs: {
                                "picture-class": "img-fluid",
                                "image-url":
                                  _vm.pluginPath + "/images/postnord.svg",
                                alt: "PostNord",
                              },
                            })
                          : shippingProfile.parcelServicePresetId == 29
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#DPD",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 30
                          ? _c("lazy-img", {
                              attrs: {
                                "picture-class": "img-fluid",
                                "image-url":
                                  _vm.pluginPath + "/images/postnord.svg",
                                alt: "PostNord",
                              },
                            })
                          : shippingProfile.parcelServicePresetId == 31
                          ? _c("lazy-img", {
                              attrs: {
                                "picture-class": "img-fluid",
                                "image-url":
                                  _vm.pluginPath + "/images/postnord.svg",
                                alt: "PostNord",
                              },
                            })
                          : shippingProfile.parcelServicePresetId == 32
                          ? [
                              _c(
                                "svg",
                                {
                                  staticClass: "scale-2-5",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-ups",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 33
                          ? _c("lazy-img", {
                              attrs: {
                                "picture-class": "img-fluid",
                                "image-url":
                                  _vm.pluginPath + "/images/postnord.svg",
                                alt: "PostNord",
                              },
                            })
                          : shippingProfile.parcelServicePresetId == 35
                          ? [
                              _c(
                                "svg",
                                {
                                  staticClass: "scale-2-5",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-ups",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 36
                          ? [
                              _c(
                                "svg",
                                {
                                  staticClass: "scale-2-5",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-ups",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 37
                          ? [
                              _c(
                                "svg",
                                {
                                  staticClass: "scale-2-5",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-ups",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 38
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#post-expres",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 39
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#dao-logo",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 40
                          ? [
                              _c(
                                "svg",
                                {
                                  staticClass: "scale-2-5",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-ups",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 41
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#dao-logo",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 43
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-dhl-express",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 44
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-dhl-express",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 45
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-dhl-express",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 46
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-dhl",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 47
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-dhl",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 48
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-dhl",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 49
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-dhl",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 50
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-dhl-express",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 51
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-dhl-express",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 52
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-dhl",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 53
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-dhl",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 54
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-dhl",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 57
                          ? [
                              _c(
                                "svg",
                                {
                                  staticClass: "mh-32",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#budbee-shipping",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 58
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#budbee-shipping",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : shippingProfile.parcelServicePresetId == 59
                          ? [
                              _c(
                                "svg",
                                {
                                  staticClass: "scale-2-5",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      "xlink:href": "#shipping-ups",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        shippingProfile.icon
                          ? _c("lazy-img", {
                              directives: [{ name: "else", rawName: "v-else" }],
                              attrs: {
                                "picture-class": "img-fluid",
                                "image-url": shippingProfile.icon,
                                alt: shippingProfile.parcelServiceName,
                                title: shippingProfile.parcelServiceName,
                              },
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "d-inline-block pl-1 pr-1 mw-40 text-center position-relative",
                      },
                      [
                        _vm.$translate(
                          "OD3dprimaV2::Template.checkoutShippingProfile" +
                            shippingProfile.parcelServicePresetId
                        ) !== "" &&
                        _vm.$translate(
                          "OD3dprimaV2::Template.checkoutShippingProfile" +
                            shippingProfile.parcelServicePresetId
                        ) !==
                          "OD3dprimaV2::Template.checkoutShippingProfile" +
                            shippingProfile.parcelServicePresetId
                          ? [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$translate(
                                      "OD3dprimaV2::Template.checkoutShippingProfile" +
                                        shippingProfile.parcelServicePresetId
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          : [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(shippingProfile.parcelServiceName) +
                                  "\n                        "
                              ),
                            ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("small", { staticClass: "checkout__shipping-price" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm._f("currency")(shippingProfile.shippingAmount)
                          ) +
                          "\n                    "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("popper", {
                  attrs: {
                    trigger: "hover",
                    placement: "bottom",
                    "body-class":
                      shippingProfile.parcelServicePresetName ||
                      (_vm.maxDeliveryDays &&
                        _vm.maxDeliveryDays[
                          shippingProfile.parcelServicePresetId
                        ])
                        ? ""
                        : "d-none",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "handle",
                        fn: function () {
                          return [
                            _c("span", { staticClass: "checkout__popover" }, [
                              _vm._v("i"),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(shippingProfile.parcelServiceName) +
                                "\n                    "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      shippingProfile.parcelServicePresetName
                                    ) +
                                    " "
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _vm.maxDeliveryDays &&
                                _vm.maxDeliveryDays[
                                  shippingProfile.parcelServicePresetId
                                ]
                                  ? [
                                      _vm._v(
                                        "\n                                - " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.checkoutShippingProfileMaxDeliveryDays",
                                              {
                                                days: _vm.maxDeliveryDays[
                                                  shippingProfile
                                                    .parcelServicePresetId
                                                ],
                                              }
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.shippingProfileList.length <= 0
            ? _c("li", { staticClass: "method-list-item has-error" }, [
                _c("div", { staticClass: "label" }, [
                  _c("div", { staticClass: "content" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$translate(
                            "Ceres::Template.notificationsCalculateShippingFailed"
                          )
                        ) +
                        "\n                    "
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }